const Tooltip = {
  defaultProps: {
    offset: 10,
    events: { hover: true, focus: true, touch: true },
    width: 250,
    multiline: true,
    transition: 'fade',
    transitionDuration: 150,
  },
  styles: (theme, _params) => ({
    tooltip: {
      backgroundColor: theme.white,
      color: theme.black,
      boxShadow: '0px 2px 12px 0px rgba(29, 38, 58, 0.08)',
    },
  }),
};

export default Tooltip;
